import { Box, Text } from '@bfa/common-ui';
import React, { ReactNode } from 'react';

const titleTextTestId = 'popup-title';

const Title = ({ children }: { children: ReactNode }) =>
  children ? (
    <Box>
      <Text
        as="h2"
        textAlign="center"
        lineHeight={['3.2rem', '4.2rem']}
        data-testid={titleTextTestId}
      >
        {children}
      </Text>
    </Box>
  ) : null;

export default Title;
